module.exports = __webpack_public_path__ + "static/media/star.5c751ff0.svg";